import React from "react"
import { useTranslation } from "react-i18next"

import { Card } from "~/components/Card/Card"
import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"
import { useLangLocation } from "~/helpers/useLangLocation"

import styles from "./index.module.css"

export const Committee: React.FC = () => {
  const { t } = useTranslation()
  const { origin } = useLangLocation("en")

  return (
    <div className={styles.Wrapper}>
      <div className="container grid grid--col-12">
        <div className={styles.ColLeft}>
          <Heading as="h2" className={styles.Title} like="h1">
            <Raw html={t("investors-and-shareholders.Committee.Title")} />
          </Heading>

          <Link
            className={styles.Link}
            href="/about/corpmanage/komitet-po-auditu-finansam-i-riskam"
            view="arrow"
          >
            <Raw html={t("investors-and-shareholders.Committee.Link")} />
          </Link>

          <div
            dangerouslySetInnerHTML={{
              __html: t("investors-and-shareholders.Committee.Description"),
            }}
          />
        </div>

        <div className={styles.ColRight}>
          <div className={styles.Cards}>
            <Card className={styles.Card}>
              <Heading className={styles.CardName} like="h2">
                <Raw html={t("investors-and-shareholders.Committee.Card.PersonalAccount.Title")} />
              </Heading>

              <Link
                href="https://online.aoreestr.ru/login"
                rel="noopener noreferrer"
                target="_blank"
                view="arrow"
              >
                <Raw html={t("investors-and-shareholders.Committee.Card.PersonalAccount.Link")} />
              </Link>
            </Card>

            {/* hidden by task: fix/2-rc9 */}
            {/*<Card className={styles.Card}>*/}
            {/*  <Heading className={styles.CardName} like="h2">*/}
            {/*    <Raw html={t("investors-and-shareholders.Committee.Card.IRBlog.Title")} />*/}
            {/*  </Heading>*/}

            {/*  <Link href={`${origin}/investors-and-shareholders/ir-blog`} view="arrow">*/}
            {/*    <Raw html={t("investors-and-shareholders.Committee.Card.IRBlog.Link")} />*/}
            {/*  </Link>*/}
            {/*</Card>*/}
          </div>
        </div>
      </div>
    </div>
  )
}
